import { getFocalPointStyles, parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    image = "image",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.image]: string;
    };
}
export interface ImageBannerStyles {
    wrapper?: InjectableCss;
}

export const styles: ImageBannerStyles = {
    wrapper: {
        css: css`
            width: 100%;
            display: flex;
            padding: 90px;
            background-position: center center;
            min-height: 464px;
            max-height: 464px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        min-height: auto;
                        padding: 30px 15px;
                    `,
                    css`
                        min-height: auto;
                        padding: 30px 15px;
                    `,
                    css`
                        min-height: auto;
                        padding: 40px;
                    `,
                    css`
                        padding: 50px;
                    `,
                    css``,
                ])}
            @media only screen and (min-width:1200px) and (max-width:1341px) {
                min-height: 437px;
                padding: 60px;
            }
        `,
    },
};

const ImageBanner: FC<OwnProps> = ({ fields, id }) => {
    const backgroundStyles = `background-image: url(${fields.image});
           background-size: cover;`;

    const wrapperStyles = {
        css: css`
            ${styles.wrapper?.css || ""}
            ${backgroundStyles}
        `,
    };

    return (
        <StyledWrapper {...wrapperStyles}>
            <Zone contentId={id} zoneName="GAIABannerImage" />
        </StyledWrapper>
    );
};

const imageBanner: WidgetModule = {
    component: ImageBanner,
    definition: {
        group: "Common",
        icon: "Banner",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.image,
                displayName: "Background",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
            },
        ],
    },
};

export default imageBanner;
